import styled from 'styled-components';
import { media } from '@minecraft.themes';

export const FilterOverlayContainer = styled.div`
  ${media.sm`
    align-items: flex-start;
    display: flex;
  `}
`;

export const FilterOverlayWrapper = styled.div`
  position: relative;
`;
